export default "__VITE_ASSET__7d47feef__"